// src/App.js
import React from "react";
import LayoutWrapper from "./LayoutWrapper";

function App() {
  return <LayoutWrapper />;
}

export default App;
